export function enumToArray<T>(enumObject: Record<string | number, T>) {
  const keys = Object.keys(enumObject);
  const enumList = keys.map((key) => enumObject[key]);
  return enumList;
}

export function getStringAsEnumValue<P extends string>(
  enumObject: Record<string | number, P>,
  key: string,
  defaultValue: P
) {
  if (!key) {
    return defaultValue;
  }
  const enumList = enumToArray(enumObject);
  return enumList?.find((k) => k.toString() === key) || defaultValue;
}

export function getOtherValuesFromEnumAsList<T>(
  enumObject: Record<string | number, T>,
  toBeRemovedValues: T[]
) {
  return Object.values(enumObject).filter(
    (value) => !toBeRemovedValues.find((val) => val === value)
  );
}
